import { useState } from 'react';
import RoleService from '../../../../services/role_service';
import DeleteRole from './DeleteRole';

const Role = (props) => {
    const [openRoleModal, setOpenRoleModal] = useState(false);
    const [roleModalMode, setRoleModalMode] = useState('create');
    const [roleName, setRoleName] = useState('');

    const deleteRole = DeleteRole({
        losesAccess: props.losesAccess,
        selectedRole: props.selectedRole,
        setLoading: props.setLoading,
        logout: props.logout,
        setRoles: props.setRoles,
        message: props.message,
        loading: props.loading,
        setRole: props.setRole
    })
    
    const handleCreateRole = async () => {
        const lostAccess = await props.losesAccess?.();
        if (lostAccess) return;
        setRoleModalMode('create');
        setRoleName('');
        setOpenRoleModal(true);
    };

    const handleEditRole = async () => {
        if (!props.selectedRole) return;
        const lostAccess = await props.losesAccess?.();
        if (lostAccess) return;
        setRoleName(props.selectedRole.Name);
        setRoleModalMode('edit');
        setOpenRoleModal(true);
    };

    const handleRoleFormChange = (e) => {
        setRoleName(e.target.value);
    };

    const handleCloseRoleModal = () => {
        if (props.loading) return;
        setOpenRoleModal(false);
        setRoleName('');
    };

    const handleSaveRole = async () => {
        const roleSave = roleName?.trim()
        props.setLoading(true);
        try {
            const lostAccess = await props.losesAccess?.();
            if (lostAccess) return;
            if (roleModalMode === 'create') {
                const create = await RoleService.create({Name: roleSave})
                if (props.logout(create)) return;
                props.setRoles(prev => [...prev, create]);
                props.setRole(create)
                props.setPermissionsRoles([])
                props.message('Rol creado con éxito', 'success');
            } else {
                const update = await RoleService.update(props.selectedRole.Id, {Name: roleSave});
                if (props.logout(update)) return;
                props.setRoles(prev =>
                    prev.map(r => r.Id === props.selectedRole.Id ? update : r)
                );
                props.setRole(update)
                props.message('Rol actualizado con éxito', 'success');
            }
            setOpenRoleModal(false);
        } catch (e) {
            props.message(e?.message || e, 'error');
        } finally {
            props.setLoading(false);
        }
    }

    return {
        ...deleteRole,
        openRoleModal,
        roleModalMode,
        roleName,
        handleSaveRole,
        handleEditRole,
        handleCreateRole,
        handleRoleFormChange,
        handleCloseRoleModal,
    }
};

export default Role;
